import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout for the creator content section. The listing renders at the bare path via
// the index route (creator.content.index.tsx); the wizard at /creator/content/create
// and the editor at /creator/content/{id} render here through <Outlet/>.
export const Route = createFileRoute('/_authenticated/_creator/_content/creator/content')({
  component: () => <Outlet />,
});
